module.exports = __webpack_public_path__ + "media/icons/nav-marketplace@3x-black-6591d628.png";